import { CURRENCY_EUR } from "./currencies";

// Work with country code at top-level as key/id
// https://en.wikipedia.org/wiki/ISO_3166-1
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#ComponentRestrictions
// used for google place autocomplete to restrict country results

export const COUNTRY_CY = "CY";

function getCountryName(countryCode) {
  const countryNameLookup = {
    CY: "Cyprus",
  };

  return countryNameLookup[countryCode] || countryCode;
}

const countryGeolocationLookup = {
  CY: {
    bounds: {
      north: 35.7,
      south: 34.1,
      west: 32.162523,
      east: 34.702225,
    },
    center: {
      lat: 35.009,
      lng: 33.21626,
    },
  },
};

export function getCountryGeolocation(countryCode) {
  return countryGeolocationLookup[countryCode] || countryCode;
}

const countryAreaLevelOneLookup = {
  CY: {
    nicosia: {
      value: "Nicosia",
      center: {
        lat: 35.1343149,
        lng: 33.3230664,
      },
    },
    limassol: {
      value: "Limassol",
      center: {
        lat: 34.7071301,
        lng: 33.0226174,
      },
    },
    larnaca: {
      value: "Larnaca",
      center: {
        lat: 34.9002535,
        lng: 33.6231723,
      },
    },
    paphos: {
      value: "Paphos",
      center: {
        lat: 34.7720133,
        lng: 32.4297369,
      },
    },
    famagusta: {
      value: "Famagusta",
      center: {
        lat: 35.0352421,
        lng: 33.983149,
      },
    },
  },
};

export const COUNTRIES = {
  CY: {
    key: 1,
    value: COUNTRY_CY,
    name: getCountryName(COUNTRY_CY),
    countryCode: COUNTRY_CY,
    bounds: getCountryGeolocation(COUNTRY_CY).bounds,
    center: getCountryGeolocation(COUNTRY_CY).center,
    currencyCode: CURRENCY_EUR,
    arealLevelOnes: [
      countryAreaLevelOneLookup[COUNTRY_CY].nicosia.value,
      countryAreaLevelOneLookup[COUNTRY_CY].limassol.value,
      countryAreaLevelOneLookup[COUNTRY_CY].larnaca.value,
      countryAreaLevelOneLookup[COUNTRY_CY].paphos.value,
      countryAreaLevelOneLookup[COUNTRY_CY].famagusta.value,
    ],
    quickLocations: [
      {
        locationName: "Nicosia",
        location: {
          areaLevelOne: countryAreaLevelOneLookup[COUNTRY_CY].nicosia.value,
          address: "Nicosia, Cyprus",
          center: countryAreaLevelOneLookup[COUNTRY_CY].nicosia.center,
        },
      },
      {
        locationName: "Limassol",
        location: {
          areaLevelOne: countryAreaLevelOneLookup[COUNTRY_CY].limassol.value,
          address: "Limassol, Cyprus",
          center: countryAreaLevelOneLookup[COUNTRY_CY].limassol.center,
        },
      },
      {
        locationName: "Larnaca",
        location: {
          areaLevelOne: countryAreaLevelOneLookup[COUNTRY_CY].larnaca.value,
          address: "Larnaca, Cyprus",
          center: countryAreaLevelOneLookup[COUNTRY_CY].larnaca.center,
        },
      },
      {
        locationName: "Paphos",
        location: {
          areaLevelOne: countryAreaLevelOneLookup[COUNTRY_CY].paphos.value,
          address: "Paphos, Cyprus",
          center: countryAreaLevelOneLookup[COUNTRY_CY].paphos.center,
        },
      },
      {
        locationName: "Famagusta",
        location: {
          areaLevelOne: countryAreaLevelOneLookup[COUNTRY_CY].famagusta.value,
          address: "Famagusta, Cyprus",
          center: countryAreaLevelOneLookup[COUNTRY_CY].famagusta.center,
        },
      },
    ],
    selectLocationOptions: [
      {
        key: 1,
        text: "Nicosia",
        value: countryAreaLevelOneLookup[COUNTRY_CY].nicosia.value,
      },
      {
        key: 2,
        text: "Limassol",
        value: countryAreaLevelOneLookup[COUNTRY_CY].limassol.value,
      },
      {
        key: 3,
        text: "Larnaca",
        value: countryAreaLevelOneLookup[COUNTRY_CY].larnaca.value,
      },
      {
        key: 4,
        text: "Paphos",
        value: countryAreaLevelOneLookup[COUNTRY_CY].paphos.value,
      },
      {
        key: 5,
        text: "Famagusta",
        value: countryAreaLevelOneLookup[COUNTRY_CY].famagusta.value,
      },
    ],
  },
};

export function getCountryProperties(countryCode) {
  return COUNTRIES[countryCode] || countryCode;
}

export function getAreaLevelOneCenter(country, areaLevelOne) {
  if (!country || !areaLevelOne) return null;
  return countryAreaLevelOneLookup[country][areaLevelOne.toLowerCase()].center;
}
